export default __webpack_public_path__ + "static/media/for_teachers_background.47125d61.jpg";